import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, Typography } from '@mui/material';
import { ProficiencyStandard } from '@/hooks/useProficiencyStandards'; // Re-evaluate if this specific import is needed or just the Level type

// Define the structure for a level, consistent with ProficiencyStandard.levels
interface Level {
  id: string;
  description: string;
  title: string; // Add title field
}

interface TargetProficiencyLevelSelectionDropdownProps {
  levels: Level[]; // Expects the array of level objects from the selected standard
  selectedLevelId?: string;
  onChange: (levelId: string) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  label?: string;
  standardName?: string; // Optional: to display if no levels are available for a selected standard
}

const TargetProficiencyLevelSelectionDropdown: React.FC<TargetProficiencyLevelSelectionDropdownProps> = ({
  levels,
  selectedLevelId,
  onChange,
  disabled = false,
  error = false,
  helperText,
  label = 'Target Proficiency Level',
  standardName,
}) => {
  if (!levels || levels.length === 0) {
    return (
      <Typography variant="body2">
        {standardName
          ? `No proficiency levels available for ${standardName}.`
          : 'No proficiency levels available. Please select a standard first.'}
      </Typography>
    );
    // Or return a disabled Select
  }

  return (
    <FormControl fullWidth error={error} disabled={disabled}>
      <Select
        id="level-selection"
        value={selectedLevelId || ''}
        onChange={(e) => { onChange(e.target.value) }}
        sx={{
            borderRadius: '16px',
            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid #D0D5DD !important',
              borderRadius: '16px !important',
            },
            '& .MuiInputBase-input': {
              padding: '14px',
              color: '#344054',
              fontWeight: 500,
            },
            '&.MuiInputBase-root': {
              height: 44,
              background: '#FFF',
              // maxWidth: maxWidth,
              width: '100%',
            },
        }}
      >
        <MenuItem value="">
          <em>Select a Level</em>
        </MenuItem>
        {levels.map((level) => (
          <MenuItem key={level.id} value={level.id}>
            {level.title} {/* Display level title */}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default TargetProficiencyLevelSelectionDropdown; 